import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "filterable-list__results-info" };
const _hoisted_2 = { class: "filterable-list__results-text" };
const _hoisted_3 = { class: "filterable-list__results-cap" };
const _hoisted_4 = { class: "filterable-list__total-item-count" };
import { useNewsFilter } from "../features/useNewsFilter";
import { useI18n } from "../features/useI18n";
import { useConfig } from "../features";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListTitle',
    setup(__props) {
        const { count } = useNewsFilter();
        const { t } = useI18n();
        const { thema } = useConfig();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, [
                    _createElementVNode("strong", _hoisted_3, _toDisplayString(_unref(t)(_unref(thema) ?? 'all')) + ":" + _toDisplayString('\xa0'), 1 /* TEXT */),
                    _createElementVNode("strong", _hoisted_4, _toDisplayString(_unref(count)) + _toDisplayString('\xa0'), 1 /* TEXT */),
                    _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(count) === 1 ? _unref(t)('result') : _unref(t)('results')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", null, "  " + _toDisplayString(_unref(t)('results_filter_txt')), 1 /* TEXT */)
                ])
            ]));
        };
    }
});
